// extracted by mini-css-extract-plugin
module.exports = {"alert":"layers_alert__3tzoX","confirmation":"layers_confirmation__3dK2d","on-screen-keyboard":"layers_on-screen-keyboard__2MS1K"};